import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import { ILoginPayload } from '@app-store/slices/auth/login.slice'
import { loginCognitoUser } from '@utils/authenticateService'
import { successLogin } from '@utils/helpers/authHelper'

interface TaskAction extends Action, ITask {}
interface ITask {
    payload: ILoginPayload
}

const { onFailure, onRequest } = rootActions.auth.login

function* fetchLoginSaga({ payload }: TaskAction) {
    try {
        const loginValues = {
            username: payload.email,
            password: payload.password,
            isActivation: payload.isActivation || false
        }
        const response = yield loginCognitoUser(loginValues)
        yield successLogin(response, payload?.sagaCB)
    } catch (e) {
        yield put(onFailure('Email or password is incorrect'))
    }
}

function* loginSaga(): any {
    yield takeLatest<TaskAction>(onRequest, fetchLoginSaga)
}

export default loginSaga
